'use strict';

angular.module('shiftTraderApp')
  .factory('Notes', function (ServerUrls, $http, $q, Session, UserPermissionsService) {
    function getBaseUrl() {
      return ServerUrls.current.railsApi + 'organizations/' + Session.getCurrentOrgId() + '/notes/';
    }

    // Fetch permissions
    var permissionsToFetch = [
      'notes.view_public',
      'notes.update_mine',
      'notes.destroy_mine',
      'notes.reply',
      'notes.view_management',
      'notes.create',
      'notes.view_admin',
      'notes.update_others',
      'notes.destroy_others'
    ];

    function initNotesRelation(nr) {
      if (nr.start_date) {
        nr.start_date = moment.utc(nr.start_date).tz(Session.getTimezone()).milliseconds(0);
      }

      if (nr.end_date) {
        nr.end_date = moment.utc(nr.end_date).tz(Session.getTimezone()).milliseconds(0);
      }

      if (nr.start_date && nr.end_date) {
        nr.range_twix = nr.start_date.twix(nr.end_date);
      } else if (nr.start_date && !nr.end_date) {
        nr.range_twix = nr.start_date.twix(moment.utc().add(20, 'years'));
      }

      return nr;
    }

    //the Model
    var Note = function(initData) {
      var N = {};
      angular.extend(N, initData);

      N.created_at = moment.utc(N.created_at).tz(Session.getTimezone());

      lodash.each(N.notes_relations, initNotesRelation);

      N.replies = lodash.map(N.replies, function(reply) {
        return Notes.initWithData(reply);
      });

      function processRawPermissions(rawPerms) {
        var isMyNote = N.user.id == Session.me;
        var myPermLevel = (rawPerms['notes.view_public']) ? 0 : -1;
        myPermLevel = (rawPerms['notes.view_management']) ? 1 : myPermLevel;
        myPermLevel = (rawPerms['notes.view_admin']) ? 2 : myPermLevel;

        N._permissions = {
          canEdit: rawPerms['notes.update_others'] || isMyNote && rawPerms['notes.update_mine'],
          canCreate: rawPerms['notes.create'],
          canDelete: rawPerms['notes.destroy_others'] || isMyNote && rawPerms['notes.destroy_mine'],
          canView: N.permission <= myPermLevel,
          canReply: rawPerms['notes.reply'],
          myPermLevel: myPermLevel
        };


        // SATODO: I don't think this should really be here... let's move this to saNote or wherever would need to know this
        N._permissions.needsContextMenu = N._permissions.canEdit || N._permissions.canDelete;
      }

      N.$getPermissions = function() {
        var deferred = $q.defer();

        if (N._permissions) {
          deferred.resolve(N._permissions);
        } else {
          UserPermissionsService.getCanDict(permissionsToFetch, N.organization_id || 'current')
            .then(function(dikt) {
              processRawPermissions(dikt);

              deferred.resolve(N._permissions);
            }, function() {
              deferred.reject();
            });
        }

        return deferred.promise;
      };



      N.$isReply = function() {
        return !lodash.isNull(N.parent_id) && !lodash.isUndefined(N.parent_id);
      };

      return N;
    };


    var Notes = {};
    Notes.getGeneralPermissions = function(orgId) {
      return UserPermissionsService.getCanDict(permissionsToFetch, orgId || 'current');
    };

    Notes.getById = function(id) {
      return $http.get(getBaseUrl() + id)
        .then(function(response) {
          return new Note(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Notes.getAll = function(data) {
      var config = {};
      if (data) {
        config = {
          params: data
        };
      }

      return $http.get(getBaseUrl(), config)
        .then(function(response) {
          return lodash.map(response.data, function(dept) {
            return new Note(dept);
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    Notes.update = function(data) {
      return $http.put(getBaseUrl() + '/' + data.id, data)
        .then(function(response) {
          return new Note(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Notes.create = function(data) {
      // Default to public
      // if (!data.permission)
      //   data.permission = 0;

      console.log(data);

      return $http.post(getBaseUrl(), data)
        .then(function(response) {
          return new Note(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Notes.initWithData = function(initData) {
      return new Note(initData);
    };

    Notes.initNew = function() {
      return Notes.initWithData({
        message: '',
        user: Session.me
      });
    };

    Notes.destroy = function(noteId) {
      return $http.delete(getBaseUrl() + noteId)
        .then(function(response) {
          console.log("Deleted Note: " + noteId);
          return Notes.initWithData(response.data);
        }, function(response) {
          return $q.reject(response);
        })
    };

    Notes.initNotesRelation = initNotesRelation;

    return Notes;
  });
